export const getRecentTenderIds = (uid: string): string[] => {
  if (!uid) {
    return [];
  }
  try {
    const data = localStorage.getItem(`recent_tenders_${uid}`);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const markTenderVisited = (uid: string, tenderId: string) => {
  if (!uid || !tenderId) {
    return;
  }
  const recent = getRecentTenderIds(uid);
  const newRecent = [tenderId, ...recent.filter((id) => id !== tenderId)].slice(0, 3);
  localStorage.setItem(`recent_tenders_${uid}`, JSON.stringify(newRecent));
  window.dispatchEvent(new Event('recentTendersUpdated'));
};

export const removeRecentTender = (uid: string, tenderId: string) => {
  if (!uid || !tenderId) {
    return;
  }
  const recent = getRecentTenderIds(uid);
  const newRecent = recent.filter((id) => id !== tenderId);
  localStorage.setItem(`recent_tenders_${uid}`, JSON.stringify(newRecent));
  window.dispatchEvent(new Event('recentTendersUpdated'));
};
